let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("alhNd")).then(() => parcelRequire('l8KTm'));